// extracted by mini-css-extract-plugin
module.exports = {"shotView":"ShotSideComponent_shotView__NxCqj"};